import React, { useState, memo, useEffect } from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MobileSide from "./MobileSide";
import { useSelector } from "react-redux";

const SideBarLinksMain = styled("div")(({ theme }) => ({
  position: "fixed",
  width: "224px",
  zIndex: 9,
}));

const IconButtonMain = styled(IconButton)(({ theme }) => ({
  position: "fixed",
  width: "40px",
  backgroundColor: theme.palette.primary.main,
  padding: "5px",
  borderRadius: "0px 12px 12px 0px",
  color: "#fff",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
  "&:hover": { backgroundColor: theme.palette.primary.main },
}));
const ShowOnDesktop = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
  [theme.breakpoints.up("lg")]: {
    display: "block",
  },
}));

const SideBarLinks = (props) => {
  const GetSidebarState = useSelector(
    (state) => state.common.ProfileMobileSidebar
  );

  useEffect(() => {
    setIsDrawerOpen(false);
  }, [GetSidebarState]);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const handleCloseNavMenu = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  const handleOpenNavMenu = () => {
    setIsDrawerOpen(true);
  };
  return (
    <SideBarLinksMain>
      <IconButtonMain
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleOpenNavMenu}
        sx={{
          display: {
            sm: "flex",
            md: "none",
            lg: "none",
          },
        }}
      >
        <MoreVertIcon />
      </IconButtonMain>
      {/* this is for the mobile */}
      <MobileSide
        isDrawerOpen={isDrawerOpen}
        handleCloseNavMenu={handleCloseNavMenu}
      >
        {props.children}
      </MobileSide>

      {/* end  */}

      <ShowOnDesktop>{props.children}</ShowOnDesktop>
    </SideBarLinksMain>
  );
};

export default memo(SideBarLinks);
